import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-world-icon]',
  template: `
    <svg:path
      d="M7.21972 0C11.2071 0 14.4399 3.23241 14.44 7.21972C14.44 11.2071 11.2071 14.44 7.21972 14.44C3.23241 14.4399 0 11.2071 0 7.21972C0.00013502 3.23249 3.23249 0.000135017 7.21972 0ZM1.02954 7.72352C1.25435 10.5254 3.33657 12.8014 6.04511 13.3199C4.84246 11.698 4.14201 9.75132 4.04225 7.72352H1.02954ZM10.3977 7.72352C10.298 9.75143 9.59709 11.698 8.39433 13.3199C11.1031 12.8016 13.1856 10.5255 13.4105 7.72352H10.3977ZM5.05155 7.72352C5.16109 9.73044 5.92267 11.6467 7.21972 13.181C8.51689 11.6467 9.2789 9.73055 9.38845 7.72352H5.05155ZM8.39433 1.11951C9.59725 2.74156 10.298 4.68842 10.3977 6.71647H13.4105C13.1857 3.91441 11.1032 1.63785 8.39433 1.11951ZM7.21972 1.25783C5.92234 2.7923 5.16109 4.70927 5.05155 6.71647H9.38845C9.2789 4.70916 8.51722 2.79235 7.21972 1.25783ZM6.04511 1.11951C3.33651 1.63803 1.25433 3.91457 1.02954 6.71647H4.04225C4.142 4.68852 4.8423 2.74151 6.04511 1.11951Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorldIcon {
  readonly viewBox = input<string>('0 0 15 15');
  readonly extraClass = input<string>('');
}